import { useEffect, useState } from "react";
import "./paperwork.scss";
import PaperworkTemplate from "componets/templates/paperwork/paperworkTemplate";
import axios from "axios";
import { baseURL } from "utilities/variables";
const Paperwork = () => {
  const [tramites, setTramites] = useState(undefined);
  const [data, setData] = useState([tramites]);
  useEffect(() => {
    let auxData = [tramites];
    setData(auxData);
  }, [tramites]);
  useEffect(() => {
    axios
      .get(
        baseURL +
          "/api/tramites?populate=acordeones&populate=imagenPrincipal.imagen"
      )
      .then((response) => {
        let auxData = response.data.data;
        let auxEasyData = [];
        auxData.map((value) => {
          auxEasyData.push({
            id: value.id,
            domain: value.attributes.dominio,
            title: value.attributes.titulo,
            description: value.attributes.descripcion,
            resume: value.attributes.descripcionResumen,
            footer: value.attributes.foorter,
            section: value.attributes.acordeones,
            urlText: value.attributes.textoURL,
            imgURL: `${baseURL}${value.attributes.imagenPrincipal.imagen.data.attributes.url}`,
            alt: value.attributes.imagenPrincipal.imagen.data.attributes
              .alternativeText,
          });
        });
        setTramites(auxEasyData);
      });
  }, []);

  return (
    <div className="Programs__main-container">
      {data[0] !== undefined && data[0].length > 0 && (
        <PaperworkTemplate dataMenu={data} />
      )}
    </div>
  );
};

export default Paperwork;
